module.exports = __webpack_public_path__ + "static/group-image1-473ea8151c91786ee9a762d99c774304.jpg";